module.exports = __webpack_public_path__ + "static/media/03.ccfa155d.png";